import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalBody,
  Heading,
  ModalHeader,
  ModalCloseButton,
  ModalFooter,
} from '@chakra-ui/react';
import { Button } from '../atoms/Button';
import { useTheme } from '../../contexts/ThemeProvider';
import { useNavigate } from 'react-router-dom';
import { useProfile } from '@/contexts/ProfileProvider';

export function ModalLoginAndPlan({ isOpen, onClose }: { isOpen: boolean; onClose: () => void }) {
  const { profile } = useProfile();
  const { colors } = useTheme();

  const navigation = useNavigate();

  return (
    <Modal onClose={onClose} isCentered isOpen={isOpen}>
      <ModalOverlay />
      <ModalContent margin={'20px'} borderRadius={'16px'}>
        <ModalHeader>{!profile ? 'Faça o Login' : 'Adquira um produto'}</ModalHeader>
        <ModalCloseButton color={colors.primaryColor} />

        <ModalBody padding="20px">
          <Heading color="#747474" fontFamily={'Glory'} fontWeight="400" fontSize={18}>
            {!profile
              ? 'Olá, notamos que você ainda não está logado. Faça o login para continuar.'
              : 'Olá, notamos que você ainda não possui um produto ativo. Adquira um produto para continuar.'}
          </Heading>
        </ModalBody>
        <ModalFooter>
          <Button
            onClick={() => {
              !profile
                ? navigation('/login')
                : navigation(`/perfil/planos`);
              onClose();
            }}
            variant="ghost"
          >
            {!profile ? 'Fazer Login' : 'Adquirir'}
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
}
